import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translationPropType, gettext } from '@eventbrite/i18n';
import { IconButton } from '@eventbrite/eds-icon-button';
import {
    STYLE_PROP_TYPE as ICON_BUTTON_STYLE_PROPTYPE,
    ICON_PROP_TYPE as ICON_BUTTON_ICON_PROPTYPE,
} from '@eventbrite/eds-icon-button';
import {
    JoyrideTourtip,
    JOYRIDE_TOURTIP_STYLES_DEFAULT,
    JOYRIDE_TOURTIP_FLOATER_STYLES_DEFAULT,
} from '@eventbrite/design-ops-ds';
import loadable from '@loadable/component';

const LazyJoyride = loadable.lib(() => import('react-joyride'));
const EventCardAction = ({
    id,
    iconType,
    style,
    title,
    secondary,
    onClick,
    isListCard,
    showLikesTooltip,
    saved,
}) => {
    let component = null;
    const iconClassName = classNames(
        `eds-event-card__actions-id__${id}`,
        'eds-event-card-content__actions-container__action',
        {
            'eds-l-pad-all-1': !isListCard,
            'eds-l-mar-right-2': !!secondary && !isListCard,
            'eds-event-card-content__actions-icon--primary': !secondary,
            'eds-event-card-content__actions-icon--secondary': !!secondary,
        },
    );

    if (iconType) {
        component = (
            <>
                {showLikesTooltip && (
                    <LazyJoyride>
                        {({ default: Joyride }) => (
                            <Joyride
                                disableOverlay
                                disableScrolling
                                steps={[
                                    {
                                        content: gettext(
                                            'Like events to help us give you better event recommendations.',
                                        ),
                                        disableBeacon: true,
                                        offset: -20,
                                        placement: 'auto',
                                        target: `.eds-event-card__actions-id__${id}`,
                                        title: gettext(
                                            'Find more events you love',
                                        ),
                                    },
                                ]}
                                tooltipComponent={JoyrideTourtip}
                                locale={{
                                    back: '',
                                    last: '',
                                }}
                                styles={JOYRIDE_TOURTIP_STYLES_DEFAULT}
                                floaterProps={{
                                    styles: JOYRIDE_TOURTIP_FLOATER_STYLES_DEFAULT,
                                }}
                            />
                        )}
                    </LazyJoyride>
                )}

                <span className={iconClassName}>
                    <IconButton
                        aria-pressed={saved}
                        title={title}
                        style={style}
                        iconType={iconType}
                        onClick={onClick}
                    />
                </span>
            </>
        );
    }

    return component;
};

export default class EventCardActions extends PureComponent {
    static propTypes = {
        id: PropTypes.string,
        primaryIconType: ICON_BUTTON_ICON_PROPTYPE,
        primaryIconStyle: ICON_BUTTON_STYLE_PROPTYPE,
        primaryIconTitle: translationPropType,
        primaryIconOnClick: PropTypes.func,
        secondaryIconType: ICON_BUTTON_ICON_PROPTYPE,
        secondaryIconStyle: ICON_BUTTON_STYLE_PROPTYPE,
        secondaryIconTitle: translationPropType,
        secondaryIconOnClick: PropTypes.func,
        shouldShowIcons: PropTypes.bool,
        isListCard: PropTypes.bool,
        showLikesTooltip: PropTypes.bool,
    };

    render() {
        const {
            id,
            primaryIconType,
            primaryIconStyle,
            primaryIconTitle,
            primaryIconOnClick,
            secondaryIconType,
            secondaryIconStyle,
            secondaryIconTitle,
            secondaryIconOnClick,
            isListCard,
            shouldShowIcons,
            showLikesTooltip,
            saved,
        } = this.props;
        const classes = classNames(
            'eds-event-card-content__actions-container eds-event-card-content__actions-container--consumer',
            {
                'eds-event-card-content__actions-container--always-visible':
                    shouldShowIcons,
            },
        );

        return (
            <div className={classes}>
                <EventCardAction
                    id={id}
                    iconType={secondaryIconType}
                    style={secondaryIconStyle}
                    title={secondaryIconTitle}
                    onClick={secondaryIconOnClick}
                    secondary={secondaryIconType}
                    isListCard={isListCard}
                    showLikesTooltip={showLikesTooltip}
                    saved={saved}
                />

                <EventCardAction
                    id={id}
                    iconType={primaryIconType}
                    style={primaryIconStyle}
                    title={primaryIconTitle}
                    onClick={primaryIconOnClick}
                    isListCard={isListCard}
                    showLikesTooltip={showLikesTooltip}
                    saved={saved}
                />
            </div>
        );
    }
}
